import getBasePath from '../functions/api-resource';

export const basePath = getBasePath('apuracao', 'reivindicacao');

const importacaoActions = {
  upload: { method: 'POST', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, importacaoActions);
